import React, { useState } from "react";
import { debounce } from "lodash";
import { UserList } from "./UserList";
import { useTranslation } from "react-i18next";

export const DebouncedSearch = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  // Función que hace la petición
  const fetchData = async (firstName, lastName) => {
    if (!firstName.trim() && !lastName.trim()) return;
    if (firstName.length >= 3 || lastName.length >= 3) {
      setLoading(true);
      try {
        const response = await fetch(`https://wallets-neon.ponzilover.com/api/names?first_name=${firstName}&last_name=${lastName}`);
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  // Debounce con lodash
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFetch = React.useCallback(debounce(fetchData, 1500), []);

  // Manejar cambios en los inputs
  const handleFirstNameChange = (e) => {
    const newFirstName = e.target.value;
    setFirstName(newFirstName);
    debouncedFetch(newFirstName, lastName);
  };

  const handleLastNameChange = (e) => {
    const newLastName = e.target.value;
    setLastName(newLastName);
    debouncedFetch(firstName, newLastName);
  };

  return (
    <div className="flex flex-col items-center justify-center bg-gray-100 p-6">
      <div className="flex items-center space-x-2">
        <span className="text-gray-700 font-semibold">{t("search")}:</span>
        <input
          type="text"
          placeholder={t("search_first_name")}
          className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={firstName}
          onChange={handleFirstNameChange}
        />
        <input
          type="text"
          placeholder={t("search_last_name")}
          className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={lastName}
          onChange={handleLastNameChange}
        />
      </div>
      {loading && <p className="mt-4 text-gray-600">Searching...</p>}
      {data && (
        <div className="mt-4 p-4 bg-white shadow-md rounded-md w-full max-w-lg">
          <h3 className="text-lg font-semibold">Results: {data.length}</h3>
          <UserList data={data} />
        </div>
      )}
    </div>
  );
};
